import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  title: '',
  message: '',
  orderId: null, // when set, tapping notification opens order details modal
};

const notificationPopupSlice = createSlice({
  name: 'notificationPopup',
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.show = true;
      state.title = action.payload?.title || 'Notification';
      state.message = action.payload?.message || '';
      state.orderId = action.payload?.orderId ?? null;
    },
    hideNotification: (state) => {
      state.show = false;
      state.title = '';
      state.message = '';
      state.orderId = null;
    },
  },
});

export const { showNotification, hideNotification } = notificationPopupSlice.actions;
export default notificationPopupSlice.reducer;
